import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * ENVIAR E-MAIL, SMS E WHATSAPP PARA A REDE — a secretaria de educação falando com as famílias de
 * todas as escolas (ou das escolas escolhidas).
 *
 * Diferente da tela da escola (`enviar_mensagem_estudantes`), aqui a configuração usada é SEMPRE a
 * da REDE: a mensagem da secretaria não pode sair pelo SMTP de uma escola. As rotas da API também
 * são outras (`MensagemEstudantes/Rede/*`), ligadas só a esta permissão — sem equivalente no
 * legado, ela fica ao lado da Configuração de envios (2200100850).
 */
export default [
  {
    description: 'Enviar E-mail, SMS e WhatsApp para a Rede',
    path: '/administracao/mensagensrede',
    name: 'enviar_mensagem_rede',
    component: () => import('@/views/administracao/mensagensrede/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ENVIARMENSAGENSREDENOVO_MENU_2200100851],
    },
    goesToMenu: true,
  },
];
